import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Navbar } from "./Navbar";
import { WorkspaceLayout } from "./WorkspaceLayout";
import { useTheme } from "../../hooks/useTheme";
import { themeFonts } from "../../utils/themes";

export default function AppLayout() {
  const location = useLocation();
  const isWorkspace = location.pathname.startsWith("/workspace");
  const { theme } = useTheme();

  const font = themeFonts[theme as keyof typeof themeFonts] || themeFonts.light;

  return (
    <div className="min-h-screen bg-base-200" style={{ fontFamily: font }}>
      <Navbar />
      {isWorkspace ? <WorkspaceLayout /> : <Outlet />}
    </div>
  );
}
